// const {
//     MinimogThemeStyles,
//     MinimogThemeScripts
// } = window;
class QuickViewUnits {
    constructor() {
      
      
    
        this.modal = new MinimogTheme.Modal, this.isOpen = !1, addEventDelegate({
            selector: ".m-units-quickview-button",
            handler: (e, i) => {
              e.preventDefault(), this.target = i, this.toggleLoading(this.target, !0);
              const t = i.dataset.productHandle;
              t && this.fetchHtml(t);
              
            }
            
       
        }), window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (() => {
            this.modal && MinimogTheme.ProductQuickView.close();
            
        }))
    }
    fetchHtml(e) {
      
      console.log(e);
      loadAssetsNew([MinimogThemeStyles.product], "quick-view-assets"), fetchSection("units-quickview", {
          url: `${window.MinimogSettings.base_url}products/${e}`
      }).then((e => {
        setTimeout(function(){
          $('html').addClass('no-scroll');
          
        },600);
          this.modalContent = e.querySelector(".m-product-quickview");
          const i = e.querySelector("product-model");
          this.mediaGallery = loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker], "variants-picker", (() => {
              this.modal.appendChild(this.modalContent), this.modal.setWidth("960px"), this.modal.open(), this.toggleLoading(this.target, !1), this.isOpen = !0
          })), i && loadAssetsNew([MinimogThemeScripts.productModel, "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"], "product-model-assets")
         
          setTimeout(function(){
            initSliderQuickview();
          },800);
        
          
        
          
        
      })).catch(console.error)
      
    }
    close(e) {
        this.modal.close(e), this.isOpen = !1
        
    }
    toggleLoading(e, i) {
        i ? e.classList.add("m-spinner-loading") : e.classList.remove("m-spinner-loading")
    }
}
MinimogTheme.ProductQuickView = new QuickViewUnits;

// quick view filter

function initSliderQuickview() {
  var imgTxtBind1 = $('.m-product-quickview--info .cart_drawer_pro:checked').data('imgbind');
  // console.log("imgTxtBind1" , imgTxtBind1);

  if(typeof(imgTxtBind1) != 'undefined'){
    let unitslocation = document.querySelector(".units_quick_wrp [data-variant-picker] input:checked").dataset.imgbind;
    // console.log(unitslocation);
    let unitsslides;
    let unitsslidesThumb;
    if(document.body.clientWidth >= 768){
      unitsslides = document.querySelectorAll(".units_quick_wrp .m-product-quickview--media media-gallery .m-product-media--slider__images .varBindImg");
      unitsslidesThumb = document.querySelectorAll(".units_quick_wrp .m-product-quickview--media .m-product-media--slider__thumbnails .varBindImg");
    }else{
      unitsslides = document.querySelectorAll(".units_quick_wrp .m-product-quickview--media media-gallery .m-product-media--slider__images .varBindImg");
      unitsslidesThumb = document.querySelectorAll(".units_quick_wrp .m-product-quickview--media .m-product-media--slider__thumbnails .varBindImg");
    }
    
    let count = 0;
     // units quickview js for filter
     unitsslides.forEach( slide => {
      if(slide.dataset.bindvar != unitslocation){
        slide.style.display = "none";
        slide.classList.add("non-swiper-slide");
        slide.classList.remove("swiper-slide");
      }else{
        slide.style.display = "block";
        slide.classList.remove("non-swiper-slide");
        slide.classList.add("swiper-slide");
        slide.dataset.index = count; 
        count++;
      }
    });

    let countThumb = 0;
    unitsslidesThumb.forEach( slide => {
      if(slide.dataset.bindvar != unitslocation){
        slide.style.display = "none";
        slide.classList.add("non-swiper-slide");
        slide.classList.remove("swiper-slide");
        slide.classList.remove("swiper-slide-thumb-active");
      }else{
        slide.style.display = "block";
        slide.classList.remove("non-swiper-slide");
        slide.classList.add("swiper-slide");
        slide.dataset.index = countThumb;
        if(countThumb == 0) slide.classList.add("swiper-slide-thumb-active");
        countThumb++;
      }

    
    });

    // onload update slider after filter 
    var mainSliderquickview = $('.units_quick_wrp .m-product-quickview--media media-gallery')[0];
    
    if($('.units_quick_wrp .m-product-quickview--media media-gallery').length > 0 && $('.units_quick_wrp .m-product-quickview--media .m-product-media--slider .swiper-container').hasClass('swiper-container-initialized')){

        mainSliderquickview.slider.updateSize();
        mainSliderquickview.slider.updateSlides();
        mainSliderquickview.slider.updateProgress();
        mainSliderquickview.slider.updateSlidesClasses();
        mainSliderquickview.slider.slideTo(0);
     
        mainSliderquickview.navSlider.updateSize();
        mainSliderquickview.navSlider.updateSlides();
        mainSliderquickview.navSlider.updateProgress();
        mainSliderquickview.navSlider.updateSlidesClasses();
        mainSliderquickview.navSlider.slideTo(0);
   
        $('.units_quick_wrp .swiper-pagination').css('opacity',1);
    }



  } 

  // quickview view onload top arrow active
  if($('body').hasClass('combo')){
    var lenghtIdx = $(`.template-product.combo .steps-list li`).length;
    var matchIdx = 0;
    $(`.template-product.combo .steps-list li`).each(function(indx){
      var indxCount = indx + 1;
      if($(this).hasClass('active')){
        matchIdx = indxCount;
      }
    });
  }else{
    var currentActiveTab = $('.tab-active a').attr('href');
    var lenghtIdx = $(`${currentActiveTab} .steps-list li`).length;
    var matchIdx = 0;
    $(`${currentActiveTab} .steps-list li`).each(function(indx){
      var indxCount = indx + 1;
      if($(this).hasClass('active')){
        matchIdx = indxCount;
      }
    });
  }
  
 

  
  $('.steps_count .btn_round').each(function(idx){
   var idx = idx + 1;
   console.log(matchIdx,"matchIdx");
    if(lenghtIdx >= idx){
      $(this).removeClass('hidden');
    }else{
      $(this).addClass('hidden');
    }
    if(matchIdx >= idx){
      
      $(this).addClass('activate'+idx);
      $(this).addClass('activate');
    }else{
      $(this).removeClass('activate');
    }
  
   
  });

  // calculate quickview navigation arrow bar activate line

  var macthh = matchIdx-1;
  var lengh = lenghtIdx - 1;
  
    
  var calwidth = 100/lengh;
  var countTotWidth = calwidth*macthh
    // console.log(countTotWidth);
  $('.steps_count').css('--myVar', countTotWidth+'%');
  
  

}


